import Router from './components/routes/Router';
function App() {
  return (
    <Router />
  )
}
export default App;
